import React from 'react';

import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import {useGlobalState} from 'hooks/useGlobalState';

import './TemplateInput.scss';

interface IProps {
  id: string;
  className?: string;
  onEditClick: () => void;
}

export default function TemplateInput({className, id, onEditClick = () => {}}: IProps) {
  const {fields} = useGlobalState((state) => state.postGenerator);

  const field = fields.find((x) => x.id === id);

  const {style, value} = field || {};

  return (
    <div className={`template-input ${className ? className : ''}`}>
      <div className="template-input__wrapper">
        <Button variant="default" className="template-input__toggle" onClick={onEditClick}>
          <Icon icon="pencil" />
        </Button>

        <p className="template-input__preview" id={id} style={style ? {...style, fontSize: `${style.fontSize}px`} : {}}>
          {value}
        </p>
      </div>
    </div>
  );
}
